import { jsx as o } from "react/jsx-runtime";
import { ModalBody as r } from "@vds-core/modals";
var t = function t(_t) {
  return o(r, Object.assign({}, _t));
};
export { t as default };